import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/devices/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/devices/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/devices/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/devices/delete',
    method: 'post',
    data
  })
}

